import React from "react";
import classNames from "classnames";
import { reviewerAvatarPastel, reviewerInitials } from "../reviews/reviewDisplayUtils";

/** Pastel initials tile — same palette logic as review list avatars. */
export default function ShopInitialBadge({
    name,
    colorKey,
    className,
}: {
    name: string;
    /** Stable string for hue (e.g. domain, uid, email). */
    colorKey: string;
    /** e.g. `ew-shop-switcher__initials--trigger` for sidebar (32px). */
    className?: string;
}) {
    const pastel = reviewerAvatarPastel(name, colorKey);
    return (
        <span
            className={classNames("ew-shop-switcher__initials", className)}
            style={{ backgroundColor: pastel.bg, color: pastel.fg }}
            aria-hidden
        >
            {reviewerInitials(name)}
        </span>
    );
}
